import styled from "styled-components";

export const ModalReceiverContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-self: center;
  max-width: 500px;
  width: 100%;
  gap: 10px;
  @media (max-width: 760px) {
    max-width: 500px;
    button {
      &:hover {
        background: transparent;
        color: #198754;
      }
    }
  }
`

export const ModalReceiverOnOff = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`
export const ModalReceiverSection = styled.div`
  border-radius: 15px;
  outline: 1px solid black;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  gap: 10px;
`

export const ModalReceiverSectionWithTab = styled(ModalReceiverSection)`
  div {
    width: 100%;
  }
`
export const ModalReceiverMode = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
`

export const ModalReceiverSectionHeader = styled.p`
  //max-width: min-content;
   padding: 0;
  margin: 0;
`

export const ModalReceiverRange = styled.div`
  display: flex;
  width: 100%;
    span {
      width: 100%;
      input {
        width: 100% !important;
      }
    }
`
export const ModalReceiverSound = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    width: 100px;
  }
`

export const ModalReceiverVolume = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  p {
    text-align: center;
    width: 30px;
    margin: 0;
    padding: 0;
  }
`

export const ModalReceiverSelect = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
`

export const ModalReceiverText = styled.p`
  padding: 0;
  margin: 0;`
export const ModalReceiverHeader = styled.h2`
  font-size: 16px;
  padding: 0;
  margin: 0 0 5px 0;
`

export const ModalReceiverNow = styled.div`
    width: 100%;
`
